import { email, maxLength, minLength, required } from 'vuelidate/lib/validators';
import { Vue, Component, Inject } from 'vue-property-decorator';
import ResetPasswordService from '@/account/reset-password/reset.password.service';
import { utils } from '@/shared/utils';

const validations = {
  resetAccount: {
    email: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(254),
      email,
    },
  },
};

interface ResetAccount {
  email: string;
}

@Component({
  validations,
})
export default class ResetPasswordInit extends Vue {
  @Inject('resetPasswordService')
  private resetPasswordService: () => ResetPasswordService;

  public success: boolean = null;
  public invalidKey: boolean = null;
  public error: string = null;
  public resetAccount: ResetAccount = {
    email: null,
  };
  public rules = {
    required: (value) => !!value || 'Your email is required.',
    max: (value) => value.length <= 100 || 'Your email cannot be longer than 100 characters.',
    min: (value) => value.length > 5 || 'Your email is required to be at least 5 characters.',
    email: (value) => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(value) || 'Hmm, that doesn\'t look like a valid email address. Mind trying again?';
    },
  };

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.query.invalidKey) {
        vm.invalidKey = to.query.invalidKey;
      }
    });
  }

  public requestReset(): void {
    this.error = null;
    this.resetPasswordService().requestReset(this.resetAccount.email)
    .then((response) => {
      if (response) {
        this.success = true;
      } else {
        this.success = null;
        this.error = 'ERROR';
      }
    });
  }

  public openLogin() {
    // this.loginService().openLogin((<any>this).$root);
    this.$router.push({
      name: 'Signin'
    });
  }

  public get year() {
    return utils.getYear();
  }

  public get isMobile() {
    return this.$vuetify.breakpoint.width < 961;
  }

  public get pageHeight() {
    return this.$vuetify.breakpoint.height;
  }
}
